import {Injectable} from '@angular/core';
import {StorageService} from './storage.service';
import {FilterType} from './filter-type';
import {PageEvent} from "@angular/material/paginator";
import {EmptyPager} from "../../modules/routing/index-entity/index-entity.component";


@Injectable({
    providedIn: 'root'
})
export class SearchStoreService implements StoreService {
    private readonly SEARCH_STORAGE_POSTFIX = '-search'

    constructor(private storage: StorageService) {
    }

    set(type: string, value: string): void {
        this.storage.setItem(type+this.SEARCH_STORAGE_POSTFIX, value);
    }

    get(type: string): string {
        const res = this.storage.getItem(type+this.SEARCH_STORAGE_POSTFIX);
        return res ?? ''
    }

    remove(type: FilterType): void {
        this.storage.removeItem(type+this.SEARCH_STORAGE_POSTFIX);
    }

}
